<template>
  <div data-testid="noa-agent-nav-group" class="fc-noa-group">
    <v-menu
      data-testid="noa-agent-nav-group__popover"
      v-model="popoverOpen"
      open-on-hover
      offset-x
      :nudge-right="12"
      :open-delay="50"
      :close-delay="150"
      :close-on-content-click="true"
      content-class="fc-noa-popover elevation-0"
      transition="fade-transition"
    >
      <template #activator="{ on, attrs }">
        <div
          data-testid="noa-agent-nav-group__activator"
          class="fc-side-nav__item"
          :class="{
            'fc-side-nav__item--mini': mini,
            'fc-side-nav__item--active': isGroupActive
          }"
          v-bind="attrs"
          v-on="on"
          role="button"
          tabindex="0"
          :aria-label="label"
        >
          <img
            v-if="icon"
            :src="icon"
            alt=""
            class="fc-side-nav__icon"
          />
          <span v-if="!mini" class="fc-side-nav__label">{{ label }}</span>
        </div>
      </template>

      <!-- Figma collapsed-nav popover: options only, no heading -->
      <div data-testid="noa-agent-nav-group__panel" class="fc-noa-popover__panel">
        <div class="fc-noa-popover__list">
          <div
            v-for="(child, index) in items"
            :key="child.href || child.name || index"
            :data-testid="`noa-agent-nav-group__popover-child--${index}`"
            class="fc-noa-popover__item"
            :class="{ 'fc-noa-popover__item--active': isChildActive(child) }"
            role="button"
            tabindex="0"
            @click="navigate(child)"
            @keyup.enter="navigate(child)"
          >
            {{ child.name }}
          </div>
        </div>
        <div class="fc-noa-popover__divider" aria-hidden="true" />
      </div>
    </v-menu>
  </div>
</template>

<script>
import { FC_NAV_ICONS } from '@/modules/financialclose/utils/constants';

export default {
  name: 'NoaAgentNavGroup',
  props: {
    mini: { type: Boolean, default: true },
    label: { type: String, default: 'Noa Agent' },
    icon: { type: String, default: FC_NAV_ICONS.AUTOMATION_AGENT },
    items: { type: Array, default: () => [] },
    selectedItem: { type: String, default: null }
  },
  emits: ['navigate'],
  data() {
    return {
      popoverOpen: false
    };
  },
  computed: {
    isGroupActive() {
      return (this.items || []).some((child) => this.isChildActive(child));
    }
  },
  methods: {
    isChildActive(child) {
      if (!child) return false;
      const href = (child.href || '').replace(/\/$/, '');
      const path = (this.$route.path || '').replace(/\/$/, '');
      return !!(href && (path === href || path.startsWith(`${href}/`)));
    },
    navigate(child) {
      if (!child?.href) return;
      this.popoverOpen = false;
      this.$emit('navigate', child);
      this.$nova.gotoLink({ path: child.href });
    }
  },
  beforeDestroy() {
    this.popoverOpen = false;
  }
};
</script>

<style lang="scss" scoped>
@import './FinancialCloseSideNav.scss';
</style>

<style lang="scss">
/* v-menu content is teleported — keep popover layout unscoped */
@import './NoaAgentNavGroup.scss';
</style>
